<ion-header>
  <app-profile-header [brand]="brandOptions" [subtitle]="subtitle" [menu]="menuOptions" routeBase="/dashboard">
  </app-profile-header>
</ion-header>
<ion-content no-bounce has-bouncing="false" forceOverscroll="false" [scrollY]="false">
  <div slot="fixed">
    <ion-router-outlet></ion-router-outlet>
  </div>
</ion-content>